import React from 'react';
import { Typography, Box } from '@mui/material';
import { useTranslation } from '../app/LanguageContext';

const HomePage = () => {
  const { translate } = useTranslation();
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {translate('home.title')}
      </Typography>
      <Typography variant="h6" color="text.secondary">
        {translate('home.subtitle')}
      </Typography>
    </Box>
  );
};

export default HomePage;



